import { reOrgTypeConstants } from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : {},
	list       : null,
	changed    : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reOrgTypeConstants.GetPaged.REQUEST:
		case reOrgTypeConstants.GetPagedAll.REQUEST:
		case reOrgTypeConstants.GetList.REQUEST:
		case reOrgTypeConstants.Create.REQUEST:
		case reOrgTypeConstants.Delete.REQUEST:
		case reOrgTypeConstants.Restore.REQUEST:
		case reOrgTypeConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reOrgTypeConstants.GetPaged.FAILURE:
		case reOrgTypeConstants.GetPagedAll.FAILURE:
		case reOrgTypeConstants.GetList.FAILURE:
		case reOrgTypeConstants.Create.FAILURE:
		case reOrgTypeConstants.Delete.FAILURE:
		case reOrgTypeConstants.Restore.FAILURE:
		case reOrgTypeConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reOrgTypeConstants.GetPaged.SUCCESS:
		case reOrgTypeConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reOrgTypeConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reOrgTypeConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reOrgTypeConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reOrgTypeConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reOrgTypeConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reOrgTypeConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : {},
				list       : null
			}
		default:
			return state
	}
}